<template>
  <div>
    <v-container fluid>
      <v-card elevation="0">
        <template v-if="checkEUDRExisting">
          <div class="d-flex mb-4 pt-10">
            <h2>
              {{ $t("deforestation.AnalysisOfDeforestationStatus") }}
              <v-tooltip top color="00BD73" max-width="350">
                <template v-slot:activator="{ on, attrs }">
                   <v-icon class="icon-with-background primary--text" style="color:#0EBF67" v-bind="attrs" v-on="on">
                          mdi-alert-circle
                    </v-icon>
                </template>
                <span>{{
                  $t("deforestation.AnalysisOfDeforestationStatusTT")
                }}</span>
              </v-tooltip>
            </h2>
            <v-spacer></v-spacer>
          </div>
          <v-row class="d-flex mb-4 mt-10">
            <v-sheet style="border: 1px solid #ccc; border-radius: 0px;"
              class="d-flex align-center justify-center flex-wrap text-center mx-auto px-4" height="200" width="100%"
              rounded>
              <v-progress-linear :indeterminate="reportLoading" v-model="progressValue" style="max-width: 90%;"
                class="mt-15" :color="progressColor" rounded :height="8"></v-progress-linear>
              <span v-if="!reportLoading" style="color: green;" class="ml-5 mt-15">{{ $t("deforestation.complete") }}</span>
              <h4 class="mb-15">
                {{
                  $t('dueDiligence.automatedDeforestationProgressText')
                }}
              </h4>
            </v-sheet>
          </v-row>
        </template>

        <v-row class="mt-10" v-if="risk">
          <v-col cols="12">
            <v-alert dense outlined color="grey lighten-4" class="mx-auto" style="max-width: 80%;">
              <div class="d-flex align-start" style="gap:8px;">
                <v-icon color="warning" small class="mt-1">mdi-alert</v-icon>
                <span class="text-body-2 grey--text text--darken-2">
                  {{ $t('dueDiligence.reviewProductionPlaceRiskAdvisory') }}
                </span>
              </div>
            </v-alert>
          </v-col>
        </v-row>

        <div class="d-flex mb-4 pt-10">
          <h2>
            {{ $t("deforestation.productionPlaces") }}
            <v-tooltip top color="00BD73" max-width="350">
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="icon-with-background primary--text" style="color:#0EBF67" v-bind="attrs"
                  v-on="on">
                  mdi-alert-circle
                </v-icon>
              </template>
              <span>{{ $t("deforestation.productionPlacesTTasd") }}</span>
            </v-tooltip>
          </h2>
          <v-spacer></v-spacer>
        </div>
        <div class="eudr-table-wrapper">
        <v-data-table  :headers="tableHeaders" :items="filterData" :items-per-page="options.limit" hide-default-footer :loading="loading"
          :options.sync="options" :loading-text="$t('deforestation.loadingProductionPlaces')
            ">
          <template v-slot:top="{ }">
            <!-- Desktop Controls -->
            <div class="filter-controls-bar d-none d-lg-flex mt-5">
              <!-- Left side: Search and Filters -->
              <div class="filter-controls-left">
                <div class="filter-item">
                  <label for="text">&nbsp;</label>
                  <v-text-field 
                    prepend-inner-icon="mdi-magnify" 
                    height="5px" 
                    :placeholder="$t('search')" 
                    dense
                    v-model="search" 
                    @input="debouncedGetProductionPlaces" 
                    class="search-field"
                    v-bind="getTextFieldProps()">
                  </v-text-field>
                </div>

                <div class="filter-item">
                  <label for="text">{{ $t("country") }}</label>
                  <v-tooltip top color="00BD73" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="icon-with-background primary--text" style="color:#0EBF67" v-bind="attrs" v-on="on">
                        mdi-alert-circle
                      </v-icon>
                    </template>
                    <span>{{ $t("deforestation.productionPlacesCountryInfo") }}</span>
                  </v-tooltip>
                  <v-autocomplete 
                    v-model="countryModel" 
                    item-text="text" 
                    item-value="val" 
                    :items="countries"
                    :label="$t('deforestation.allCountries')" 
                    @change="getProductionPlaces" 
                    dense
                    v-bind="getSelectProps()">
                  </v-autocomplete>
                </div>

                <div class="filter-item">
                  <label for="text">{{ $t('deforestation.EUDRDeforestationStatus') }}</label>
                  <v-tooltip top color="00BD73" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="icon-with-background primary--text" style="color:#0EBF67" v-bind="attrs" v-on="on">
                        mdi-alert-circle
                      </v-icon>
                    </template>
                    <span>{{ $t("deforestation.EUDRDeforestationStatusTT") }}</span>
                  </v-tooltip>
                  <v-autocomplete  
                    v-model="statusModel" 
                    item-text="text" 
                    item-value="val" 
                    :items="allStatus"
                    @change="getProductionPlaces" 
                    dense
                    v-bind="getSelectProps()">
                  </v-autocomplete>
                </div>
              </div>

              <!-- Right side: Pagination and Actions -->
              <div class="filter-controls-right">
                <div class="pagination-info">
                  {{ from }} - {{ to }} of {{ totalProductionPlaces }}
                </div>
                <v-btn 
                  class="mx-2" 
                  fab 
                  small 
                  outlined 
                  color="primary" 
                  :disabled="options.page <= 1"
                  @click="pageChange(false)"
                  v-bind="getButtonProps()">
                  <v-icon dark>
                    mdi-chevron-left
                  </v-icon>
                </v-btn>
                <v-btn 
                  class="mx-2" 
                  fab 
                  small 
                  outlined 
                  color="primary" 
                  :disabled="options.page >= totalPages"
                  @click="pageChange(true)"
                  v-bind="getButtonProps()">
                  <v-icon dark>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
                <v-menu v-model="customizeMenu" :close-on-content-click="false" :nudge-width="200"
                  left :min-width="417">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="mx-2" fab small outlined color="primary" v-bind="{...attrs, ...getButtonProps()}" v-on="on">
                      <v-icon dark> mdi-cog-outline </v-icon>
                    </v-btn>
                  </template>

                  <v-card width="417">
                    <v-list>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>{{
                            $t("deforestation.customization")
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <div class="pl-3 pt-2 font-weight-normal">
                        {{ $t("deforestation.recordsPerpage") }}
                      </div>
                      <v-list-item>
                        <v-list-item-content>
                          <v-slider v-model="itemsPerPageSlider"
                            :tick-labels="itemsPerPageOptions" :max="3" step="1"
                            ticks="always" tick-size="4"></v-slider>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-n3"></v-divider>
                    </v-list>
                    <v-card-text>
                      <v-container fluid>
                        <v-row>
                          <v-col class="mt-n9" cols="6" v-for="header in headers" :key="header.value">
                            <v-checkbox v-if="header.text.length > 0" v-model="selectedHeaders" :label="header.text"
                              color="primary" :value="header.text" hide-details
                              :disabled="header.text == 'ID' || header.text == 'Tag'"></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-layout justify-center>
                      <v-card-actions class="mb-5">
                        <v-spacer></v-spacer>
                        <v-btn outlined color="primary" @click="resetDefault" width="190">
                          {{ $t("deforestation.restoreDefault") }}
                        </v-btn>
                        <v-btn color="primary" @click="resetTableStructure" width="190">
                          {{ $t("deforestation.apply") }}
                        </v-btn>
                      </v-card-actions>
                    </v-layout>
                  </v-card>
                </v-menu>
                <v-btn class="mx-2" @click="exportToPDF" fab small outlined color="primary" v-bind="getButtonProps()">
                  <v-icon dark>
                    mdi-tray-arrow-down
                  </v-icon>
                </v-btn>
              </div>
            </div>

            <!-- Show Farm With Issues row (desktop) -->
            <div class="filter-controls-checkbox-row d-none d-lg-flex">
              <v-checkbox
                label="Show Farm With Issues"
                v-model="issue_farm"
                hide-details
                dense
                class="ma-0 pa-0"
                @change="handleCheckboxWithIssue">
              </v-checkbox>
            </div>

            <!-- Mobile Controls -->
            <div class="mobile-controls d-flex d-lg-none mt-5">
              <div class="mobile-search">
                <v-text-field 
                  prepend-inner-icon="mdi-magnify" 
                  dense
                  :placeholder="$t('search')" 
                  v-model="search" 
                  @input="debouncedGetProductionPlaces"
                  v-bind="getTextFieldProps()">
                </v-text-field>
              </div>
              <div class="mobile-filters">
                <v-autocomplete 
                  v-model="countryModel" 
                  item-text="text" 
                  item-value="val" 
                  :items="countries"
                  :label="$t('deforestation.allCountries')" 
                  @change="getProductionPlaces" 
                  dense
                  v-bind="getSelectProps()">
                </v-autocomplete>
                <v-autocomplete  
                  v-model="statusModel" 
                  item-text="text" 
                  item-value="val" 
                  :items="allStatus"
                  @change="getProductionPlaces" 
                  dense
                  v-bind="getSelectProps()">
                </v-autocomplete>
              </div>
            </div>

            <!-- Mobile Pagination -->
            <div class="mobile-pagination d-flex d-lg-none mt-3">
              <div class="mobile-pagination-info">
                {{ from }} - {{ to }} of {{ totalProductionPlaces }}
              </div>
              <div class="mobile-pagination-controls">
                <v-btn 
                  fab 
                  small 
                  outlined 
                  color="primary" 
                  :disabled="options.page <= 1"
                  @click="pageChange(false)"
                  v-bind="getButtonProps()">
                  <v-icon dark>
                    mdi-chevron-left
                  </v-icon>
                </v-btn>
                <v-btn 
                  fab 
                  small 
                  outlined 
                  color="primary" 
                  :disabled="options.page >= totalPages"
                  @click="pageChange(true)"
                  v-bind="getButtonProps()">
                  <v-icon dark>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
              </div>
            </div>
          </template>
            <template v-if="filterData.length" v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id" style="position: relative; width: 0; height: 0"
                  @mouseover="selectItem(item)" @mouseleave="selectItem(false)">
                  <template v-for="h in tableHeaders">
                  <td v-if="h.value == 'farm.farmName'" :key="h.value" class="text-truncate">
                    {{ item.farm.farmName || "N/A" }}<br />
                    {{ item.farm.id }}
                  </td>

                  <td v-if="h.value == 'farm.userDdsAssoc.fullName'" :key="h.value"  class="text-truncate">
                    {{ item.farm.userDdsAssoc.firstName }}
                    {{ item.farm.userDdsAssoc.lastName }}
                  </td>

                  <td v-if="h.value == 'farm.address'" :key="h.value"  class="text-truncate" style="max-width: 300px;">
                    {{ item.farm.address }}
                  </td>

                  <td v-if="h.value == 'farm.area'" :key="h.value"  class="text-truncate">
                    {{ item.farm.area ? parseFloat(item.farm.area * 0.404686).toFixed(5) : '' }}
                  </td>

                  <td v-if="h.value == 'farmType'" :key="h.value"  class="text-truncate">
                    {{ $t(`deforestation.${item.farmType}`) }}
                  </td>

                  <td v-if="h.value == 'eudr_deforestation_status'" :key="h.value" >
                    <div v-if="checkEUDRExisting" class="eudr_class">

                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on"
                            small rounded depressed
                            :class="[getEUDRDeforestationStatus(item.deforestationStatus || item.errorStatus).class, 'non-clickable']"
                            height="34">
                            {{ getEUDRDeforestationStatus(item.deforestationStatus || item.errorStatus).text }}
                          </v-btn>

                        </template>
                        <span>{{ getEUDRDeforestationStatus(item.deforestationStatus ||
                          `${item.errorStatus}_tt`).text}}</span>
                      </v-tooltip>

                    </div>
                    <template v-else>
                      <div class="d-flex justify-center" v-if="item.eudr_deforestation_status && !item.isExpired">
                        <template v-if="getEUDRDeforestationStatus(item.eudr_deforestation_status).text !== 'N/A'">
                          <v-btn class="mr-2" small rounded min-width="200" depressed :class="getEUDRDeforestationStatus(item.eudr_deforestation_status).class" height="34"
                        v-bind="getButtonProps()">
                          {{ getEUDRDeforestationStatus(item.deforestationStatus).text }}
                        </v-btn>
                        <img class="mr-2"  @click="handleViewEudrAssessment(item)" :src="isIndonesianClient ? '/img/id/todo-list.svg' : isKenyaClient ? '/img/ke/todo-list.svg' : '/icons/todo-list.png'" style="width: 34px; height: 34px; border-radius: 50%;" />
                        
                          <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                  <v-icon 
                                  v-bind="attrs"
                                  v-on="on" 
                                  color="primary" 
                                  class="cursor-pointer" 
                                  @click="onClickRemoveDeforestationStatus(item.farm)">
                                  mdi-delete
                                  </v-icon>
                              </template>
                              <span>{{ $t('deforestation.removeEudrDeforestationStatus') }}</span>
                          </v-tooltip>
                        </template>
                      </div>
                      <span class="text-decoration-underline cursor-pointer" v-else
                        @click="handleUploadEudrAssessment(item)" v-bind="getButtonProps()">{{ $t('uploadAssessment') }}</span>
                    </template>
                  </td>

                  <td v-if="h.value == 'status'" :key="h.value" >
                    <div class="d-flex">
                      <v-menu v-if="checkEUDRExisting">
                        <template v-slot:activator="{ on }">
                          <v-btn x-small fab v-on="on" color="primary">
                            <img :src="isIndonesianClient ? '/img/id/todo-list.svg' : isKenyaClient ? '/img/ke/todo-list.svg' : '/icons/todo-list.png'" style="width: 34px; height: 34px; border-radius: 50%;" />
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item v-for="(menu, i) in (item.deforestationInfo && item.deforestationInfo.deforestationStatus ? menus : menusWithoutReport)" :key="i" :disabled="menu.disabled">
                            <v-list-item-title :class="menu.disabled ? '' : 'cursor-pointer'" @click="!menu.disabled && showModel(menu.id, item)">{{ menu.title }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <div>
                        <v-icon class="ml-5 primary--text" style="margin-left: 20px;"
                        @click="removeFarm(item.farmId)" v-bind="getButtonProps()">mdi-trash-can</v-icon>
                      </div>
                    </div>
                  </td>
                  </template>
                </tr>
              </tbody>
            </template>
            <template v-slot:footer></template>
          </v-data-table>
        </div>

        <template>
          <div class="d-flex mt-5" style="align-items: center;">
            <v-spacer></v-spacer>
            <img :src="isIndonesianClient ? '/img/id/todo-list.svg' : isKenyaClient ? '/img/ke/todo-list.svg' : '/icons/todo-list.png'" style="width: 34px; height: 34px; border-radius: 50%;" />
            <span class="ml-2">{{ $t("dueDiligence.viewReport") }}</span>
            <v-icon class="ml-5 primary--text">mdi-trash-can</v-icon>
            <span class="ml-2">{{ $t("delete") }}</span>
          </div>
        </template>
        <v-row class="my-10 mx-2" v-if="productionPlaces.length">
          <template v-if="!checkEUDRExisting">
            <v-btn color="primary" dark class="mr-2 mb-2" @click="handleUploadEudrAssessment(productionPlaces)" v-bind="getButtonProps()">
              {{ $t("uploadOneDeforestationAssessmentForAllFarms") }}
            </v-btn>
          </template>
          <template v-else>
            <v-btn color="primary" dark class="bulk-action-btn" @click="removeAllHighRiskFarm" v-bind="getButtonProps()">
              {{ $t("deforestation.removeAllHighRiskFarm") }}
            </v-btn>
            <v-btn color="primary" dark class="bulk-action-btn" @click="removeAllMediumRiskFarm" v-bind="getButtonProps()">
              {{ $t("deforestation.removeAllMediumRiskFarm") }}
            </v-btn>
            <v-btn color="primary" dark class="bulk-action-btn" @click="removeAllLowRiskFarm" v-bind="getButtonProps()">
              {{ $t("deforestation.removeAllLowRiskFarm") }}
            </v-btn>
            <div class="bulk-action-buttons__attach">
              <v-btn color="primary" dark class="bulk-action-btn bulk-action-btn--attach" @click="triggerFileInput" v-bind="getButtonProps()">
                {{ $t("deforestation.attachRiskMigrationDoc") }}
              </v-btn>
              <v-tooltip top color="black" max-width="220">
                <template v-slot:activator="{ on, attrs }">
                    <v-icon class="icon-with-background primary--text bulk-action-buttons__info" style="color:#0EBF67" v-bind="attrs" v-on="on">
                      mdi-alert-circle
                    </v-icon>
                </template>
                <span>{{ $t("deforestation.attachRiskMigrationDocTT") }}</span>
              </v-tooltip>
            </div>

            <input type="file" ref="fileInput" accept="application/pdf" @change="handleFileChange" style="display: none;" />
          </template>
        </v-row>

        <v-card
          v-if="fileUploading || highRiskComment || s3Location"
          outlined
          class="mitigation-panel mt-6"
        >
          <v-card-text class="pa-4 pa-md-5">
            <div
              class="mitigation-panel__grid"
              :class="{ 'mitigation-panel__grid--with-doc': s3Location || fileUploading }"
            >
              <div v-if="s3Location || fileUploading" class="mitigation-panel__document">
                <div class="mitigation-panel__label">{{ $t('dueDiligence.mitigationDocuments') }}</div>
                <div class="mitigation-panel__doc-card" @click="s3Location && openPdf()">
                  <v-icon color="error" size="36">mdi-file-pdf-box</v-icon>
                  <div class="mitigation-panel__doc-meta">
                    <span class="mitigation-panel__doc-name text-truncate">{{ uploadedFileName || uploadFileType }}</span>
                    <v-btn
                      v-if="s3Location"
                      text
                      small
                      color="primary"
                      class="pa-0 mt-1"
                      @click.stop="openPdf"
                    >
                      <v-icon small left>mdi-eye</v-icon>
                      {{ $t('dueDiligence.viewReport') }}
                    </v-btn>
                  </div>
                </div>
                <v-progress-linear
                  v-if="fileUploading"
                  indeterminate
                  color="primary"
                  class="mt-2"
                  rounded
                  height="4"
                />
              </div>
              <div class="mitigation-panel__comments">
                <div class="mitigation-panel__label">{{ $t('dueDiligence.mitigationComments') }}</div>
                <v-textarea
                  v-model="highRiskComment"
                  :rows="3"
                  outlined
                  dense
                  hide-details
                  full-width
                  class="mitigation-panel__textarea"
                  :placeholder="$t('activationKey.comments')"
                  @input="handleHightRiskMitigation"
                  v-bind="getTextareaProps()"
                />
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-card>

      <div v-if="removedProductionPlaces.length" class="removed-farms-section mt-8">
        <div class="removed-farms-section__header">
          <div class="removed-farms-section__title-wrap">
            <h3 class="removed-farms-section__title">{{ $t("deforestation.removedFarms") }}</h3>
          </div>
          <div class="removed-farms-section__pagination">
            <span class="pagination-info">
              {{ removedFrom }} - {{ removedTo }} of {{ totalRemovedProductionPlaces }}
            </span>
            <v-btn
              class="mx-1"
              fab
              small
              outlined
              color="primary"
              :disabled="removedProductionPlaceOptions.page <= 1"
              @click="pageChangeRemovedProductionPlace(false)"
              v-bind="getButtonProps()"
            >
              <v-icon dark>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
              class="mx-1"
              fab
              small
              outlined
              color="primary"
              :disabled="removedProductionPlaceOptions.page >= totalRemovedPages"
              @click="pageChangeRemovedProductionPlace(true)"
              v-bind="getButtonProps()"
            >
              <v-icon dark>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </div>

        <div class="removed-farms-section__legend table-legend d-flex flex-wrap align-center pb-4">
          <div class="removed-farms-section__legend-item">
            <img :src="isIndonesianClient ? '/img/id/todo-list.svg' : isKenyaClient ? '/img/ke/todo-list.svg' : '/icons/todo-list.png'" alt="" />
            <span>{{ $t("dueDiligence.viewReport") }}</span>
          </div>
          <div class="removed-farms-section__legend-item">
            <img src="/icons/undo.png" alt="" />
            <span>{{ $t("deforestation.undoDelete") }}</span>
          </div>
        </div>

        <div class="eudr-table-wrapper removed-farms-table">
          <v-data-table
            :headers="headersRemoveFarm"
            :items="removedProductionPlaces"
            :items-per-page="options.limit"
            hide-default-footer
            :loading="removedLoading"
            :options.sync="removedProductionPlaceOptions"
            :loading-text="$t('deforestation.loadingProductionPlaces')"
          >
            <template v-if="removedProductionPlaces.length" v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id" @mouseover="selectItem(item)" @mouseleave="selectItem(false)">
                  <td class="text-truncate">
                    {{ item.farm.farmName || "N/A" }}<br />
                    {{ item.farm.id }}
                  </td>

                  <td class="text-truncate">
                    {{ item.farm.userDdsAssoc.firstName }}
                    {{ item.farm.userDdsAssoc.lastName }}
                  </td>

                  <td class="text-truncate removed-farms-table__address">
                    {{ item.farm.address }}
                  </td>

                  <td class="text-truncate">
                    {{ item.farm.area ? parseFloat(item.farm.area * 0.404686).toFixed(5) : '' }}
                  </td>

                  <td class="text-truncate eudr-type-col">
                    {{ item.farmType }}
                  </td>

                  <td class="eudr-status-col">
                    <div class="eudr_class">
                      <v-tooltip top color="black" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            v-if="getEUDRDeforestationStatus(item.deforestationStatus || item.errorStatus).text !== 'N/A'"
                            small
                            rounded
                            depressed
                            :class="getEUDRDeforestationStatus(item.deforestationStatus || item.errorStatus).class"
                            height="34"
                          >
                            {{ getEUDRDeforestationStatus(item.deforestationStatus || item.errorStatus).text }}
                          </v-btn>
                          <span v-else>N/A</span>
                        </template>
                        <span>{{ getEUDRDeforestationStatus(item.deforestationStatus || `${item.errorStatus}_tt`).text }}</span>
                      </v-tooltip>
                    </div>
                  </td>

                  <td class="eudr-actions-col">
                    <div class="d-flex align-center justify-center removed-farms-table__actions">
                      <v-tooltip v-if="!!(item.deforestationInfo && item.deforestationInfo.deforestationStatus)" top color="00BD73" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <img
                            v-bind="attrs"
                            v-on="on"
                            class="removed-farms-table__action-icon"
                            @click="$router.push({
                              name: 'EudrAssessmentReport',
                              params: { id: item.deforestationInfo.deforestationReportRequestId, type: 'assignment' },
                            })"
                            :src="isIndonesianClient ? '/img/id/todo-list.svg' : isKenyaClient ? '/img/ke/todo-list.svg' : '/icons/todo-list.png'"
                            alt=""
                          />
                        </template>
                        <span>{{ $t('dueDiligence.viewReport') }}</span>
                      </v-tooltip>
                      <v-tooltip top color="00BD73" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <img
                            v-bind="{ ...attrs, ...getButtonProps() }"
                            v-on="on"
                            class="removed-farms-table__action-icon"
                            @click="restoreFarm(item.id)"
                            src="/icons/undo.png"
                            alt=""
                          />
                        </template>
                        <span>{{ $t("deforestation.undoDelete") }}</span>
                      </v-tooltip>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
            <template v-slot:footer></template>
          </v-data-table>
        </div>
      </div>
    </v-container>
    <DisputesDialog v-if="showDisputeModal" :dialogU="showDisputeModal" :reportRequestId="targetProductionPlaceDeforestationId"
      @closeDisputeDialog="showDisputeModal = false"></DisputesDialog>
    <MitigationDialog v-if="showMitigtionModal" :dialogU="showMitigtionModal"
      :manualRiskMitigationData="getManualRiskMitigationData" :productionPlaceId="targetedProductionPlaceId" :productionPlaceDetail="targetProductionPlace" @closeBulkUpload="showMitigtionModal = false" @mitigated="callbackMitigation"></MitigationDialog>
    <UploadAssessment v-if="showUploadAssessment" :dialog="showUploadAssessment"
      :productionPlaceDetails="currentProductionDetails" :diligenceReportID="diligenceId"
      @closeUploadAssessmentModal="showUploadAssessment = false"
      @saveEudrAssessment="uploadedEudrDeforestations"></UploadAssessment>
    <ViewAssessment v-if="showViewAssessment" :dialog="showViewAssessment"
      :productionPlaceDetails="currentProductionDetails" :diligenceReportID="diligenceId"
      @closeViewAssessmentModal="showViewAssessment = false"
      @saveEudrAssessment="uploadedEudrDeforestations"></ViewAssessment>
      <confirm-box 
        ref="removeEudrDeforestationStatus"
        v-if="eudrDeforestationStatusConfirmDelete.dialog"
        v-bind="eudrDeforestationStatusConfirmDelete" 
        v-on="eventHandlersDeforestationStatus" 
        />
      <confirm-box 
      :title="farmConfirmDelete.title"
      :message="farmConfirmDelete.message"
      :cancelBtnText="farmConfirmDelete.cancelBtnText" 
      :confirmBtnText="farmConfirmDelete.confirmBtnText"
      :confirmData="farmConfirmDelete.confirmData" 
      :dialog="farmConfirmDeleteDialog" 
      @cancel:action="farmConfirmDeleteDialog = false"
      @continue:action="confirmRemoveFarm" />
      <ProcessingDialog
        :dialog="showProcessingDialog"
        @close="onProcessingDialogClose"
        :description="analyzingDeforestation.analyzingDesc"
        :heading="analyzingDeforestation.analyzingStatus"
        :startTimerModel="startTimer"
        :hasTimer="true"
      />

      <v-dialog v-model="nextConfirmDialog" max-width="560" @click:outside="cancelNextStep">
        <v-card class="eudr-proceed-dialog-card">
          <v-btn icon small class="eudr-proceed-dialog__close" aria-label="Close" @click="cancelNextStep">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <div class="text-center px-6 pt-7 pb-4">
            <div class="eudr-proceed-dialog__icon-wrap">
              <v-icon size="30" color="error">mdi-close-octagon</v-icon>
            </div>
            <div class="text-h6 font-weight-bold black--text mb-2">
              {{ $t('dueDiligence.eudrAssessmentCannotProceedTitle') }}
            </div>
            <p class="text-body-2 black--text mb-2">
              <strong class="eudr-proceed-dialog__lead">{{ riskDetectedProceedMessage }}</strong>
            </p>
            <p class="text-body-2 text--secondary mb-3">
              {{ $t('dueDiligence.eudrAssessmentCannotProceedSubtext') }}
            </p>

            <v-sheet
              v-if="blockingEudrFarms.length"
              outlined
              rounded
              class="text-left pa-3 mb-3 eudr-proceed-dialog__farm-list"
            >
              <div
                v-for="farm in blockingEudrFarms.slice(0, 8)"
                :key="farm.id"
                class="d-flex align-center justify-space-between py-1"
              >
                <span class="text-body-2 text-truncate mr-2">
                  {{ farm.farm?.farmName || ('Farm ' + (farm.farm?.id || farm.id)) }}
                </span>
                <v-btn x-small depressed outlined color="red" class="red-button">
                  {{ getEUDRDeforestationStatus(getProductionPlaceEudrStatus(farm)).text }}
                </v-btn>
              </div>
              <div v-if="blockingEudrFarms.length > 8" class="text-caption text--secondary mt-1">
                + {{ blockingEudrFarms.length - 8 }} more
              </div>
            </v-sheet>

            <v-sheet rounded class="text-left pa-3 eudr-proceed-dialog__helper">
              <div class="d-flex align-center mb-2">
                <v-icon small color="primary" class="mr-2">mdi-lightbulb-on-outline</v-icon>
                <span class="text-subtitle-2 font-weight-bold primary--text">
                  {{ $t('dueDiligence.eudrAssessmentCannotProceedHelperTitle') }}
                </span>
              </div>
              <ol class="eudr-proceed-dialog__helper-steps text-body-2 mb-0 pl-0">
                <li>{{ $t('dueDiligence.eudrAssessmentCannotProceedStep1') }}</li>
                <li>{{ $t('dueDiligence.eudrAssessmentCannotProceedStep2') }}</li>
                <li>{{ $t('dueDiligence.eudrAssessmentCannotProceedStep3') }}</li>
                <li>{{ $t('dueDiligence.eudrAssessmentCannotProceedStep4') }}</li>
              </ol>
              <div class="eudr-proceed-dialog__timing-note d-flex align-start mt-3">
                <v-icon x-small color="primary" class="mr-2 mt-1">mdi-clock-outline</v-icon>
                <span class="text-caption text--secondary">
                  {{ $t('dueDiligence.eudrAssessmentCannotProceedTimelineNote') }}
                </span>
              </div>
            </v-sheet>
          </div>
          <v-card-actions class="px-5 pb-5 pt-1 d-flex eudr-proceed-dialog__actions">
            <v-btn outlined color="primary" class="flex-grow-1" @click="cancelNextStep">
              {{ $t('dueDiligence.eudrAssessmentCannotProceedGoBack') }}
            </v-btn>
            <v-btn depressed color="primary" class="flex-grow-1" disabled>
              {{ $t('dueDiligence.eudrAssessmentCannotProceedTitle') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin";
import download from "@/mixins/DownloadMixin";
import getPermittedActions from "@/mixins/GetPermittedActions";
import DateMixin from "@/mixins/DateMixin";
import DeforestationService from "@/_services/DeforestationService";
import ActivityLogService from "@/_services/ActivityLogService";
import DisputesDialog from "../components/eudr/DisputesDialog.vue";
import MitigationDialog from "../components/eudr/MitigationDialog.vue";
import S3UploadService from "@/_services/S3UploadService";
import UploadAssessment from '../components/eudr/UploadAssessment.vue';
import ViewAssessment from '../components/eudr/ViewAssessment.vue';
import { mapGetters } from 'vuex'
import { debounce } from 'lodash'
import { isDeforestationExpired, isKenyaClient, wait, getEUDRDeforestationStatus, isAllowedPtsiEudrProceedStatus } from '@/utils';
import ConfirmBox from "@/components/ConfirmBox";
import ProcessingDialog from '../components/ProcessingDialog.vue';
import tableCustomizationMixin from "@/mixins/tableCustomizationMixin";
import { isIndonesianClient } from "@/utils";
import reportReadonlyMixin from "@/mixins/reportReadonlyMixin";
import { DDS_MITIGATION_SOURCE_TYPE } from "@/utils/ddsMitigationSourceType";
import { findProductionPlaceForMitigation } from "@/utils/ddsMitigationNotification";

export default {
  components: {
    MitigationDialog,
    DisputesDialog,
    UploadAssessment,
    ViewAssessment,
    ProcessingDialog,
    "confirm-box": ConfirmBox,

  },
  created() {
    const prefs = this.getTablePrefs('ProductionPlacesTable');
    if (prefs) {
      this.selectedHeaders = prefs.selectedHeaders;
      this.itemsPerPageSlider = this.itemsPerPageOptions.indexOf(prefs.itemsPerPage);
    } else {
      this.selectedHeaders = this.allSelectedHeaders;
      this.itemsPerPageSlider = 1;
    }
    this.options.limit = this.itemsPerPageOptions[this.itemsPerPageSlider];
    this.tableHeaders = this.headers.filter(h => this.selectedHeaders.includes(h.text));
    this.setEventHandlers();
  },

  async mounted() {
    this.$emit('goToEudrStep');
    // Only the bulk-report job blocks the page (it drives its own processing dialog);
    // the lists below have table loaders.
    if (this.checkEUDRExisting) {
      this.startLoading();
      try {
        await this.getBulkDeforestationReport();
      } finally {
        this.stopLoading();
      }
    }
    await this.fetchData();
    await this.handleMitigationDeepLink();
    this.$store.dispatch('eudrDDS/setDiligenceData', {
      diligenceId: this.diligenceId
    });
    this.$store.dispatch('SET_DDS_CURRENT_TAB_TO_DB', {
      step: (4 + this.stepOffset),
      reportId: Number(this.diligenceId)
    })
    this.$emit('calculateWarningsForDeforestationAssessment', this.diligenceId);
  },
  props: {
    diligenceId: {
      type: Number,
      required: true,
    },
    updatedProductionPlaces: {
      type: Array,
    },
  },
  computed: {
    isKenyaClient() {
      return isKenyaClient();
    },
    isIndonesianClient() {
      return isIndonesianClient();
    },
    ...mapGetters("eudrDDS", ["getDiligenceDetails", "getDdsUserRole"]),
    ...mapGetters("eudrSettings", ["get_EUDR_Settings"]),
    targetProductionPlaceDeforestationId() {
      if(!this.targetProductionPlace) return null;
      return this.targetProductionPlace.diligenceReportProductionPlaceArray[0]?.productionPlaceDeforestationInfo?.deforestationReportRequestId;
    },
    totalPages() {
      return parseInt(Math.ceil(this.totalProductionPlaces / 10));
    },
    isLocalDBVerificationEnable(){
      if(!this.get_EUDR_Settings?.local_db_verification_config) return null
      const parseVal = JSON.parse(this.get_EUDR_Settings?.local_db_verification_config) 
      return parseVal?.enabled || false;
    },
    stepOffset(){
      return this.isLocalDBVerificationEnable ? 1 : 0;
    },
    totalRemovedPages() {
      return parseInt(Math.ceil(this.totalRemovedProductionPlaces / 10));
    },
    getCurrentUser() {
      return this.$store.getters.getUser;
    },
    filterData() {
      if (
        (this.countryModel && this.countryModel !== "") ||
        (this.producerModel && this.producerModel !== "") ||
        (this.statusModel && this.statusModel !== "")
      ) {
        const list = this.productionPlaces.filter((item) => {
          return (
            // (!this.countryModel[0] ||
            //   item.farm.userDdsAssoc.countryId === this.countryModel[0]) &&
            (!this.producerModel ||
            item.farm.userDdsAssoc.firstName === this.producerModel) &&
            (!this.statusModel ||
              (item.deforestationStatus || item.eudr_deforestation_status) === this.statusModel)
          );
        });
        return list;
      } else {
        return this.productionPlaces;
      }
    },
    checkEUDRExisting(){
      return this.updatedEUDRAssessmentType === 'Dimitra Deforestation Report' ? true : false;
    },
    menusWithoutReport() {
      return this.menus.filter(menu => menu.id !== 'assessment' && menu.id !== 'disputes');
    },
    menus() {
      return [
        { title: this.$t('dueDiligence.viewAssessment'), id: "assessment", disabled: false },
        { title: this.$t('dueDiligence.disputes'), id: "disputes", disabled: this.isReadonlyMode },
        { title: this.$t('dueDiligence.manualRiskMitigation'), id: "mitigation", disabled: this.isReadonlyMode },
      ];
    },
    blockingEudrFarmCount() {
      console.log('blockingEudrFarms:', this.blockingEudrFarms);
      return (this.blockingEudrFarms || []).length
    },
    riskDetectedProceedMessage() {
      return this.$tc('dueDiligence.eudrAssessmentRiskDetectedInPlaces', this.blockingEudrFarmCount, {
        count: this.blockingEudrFarmCount,
      })
    },
  },
 
  data() {
    return {
      nextConfirmDialog: false,
      blockingEudrFarms: [],
      issue_farm:false,
      startTimer: 0,
      customizeMenu:false,
      itemsPerPageSlider: 1,
      itemsPerPageOptions: [5, 10, 25, 50],
			customizeMenuAll: '',
      selectedHeaders: [
      ],
      tableHeaders:[

      ],
      allSelectedHeaders:[
        this.$t("deforestation.productionPlacesFarmAndFarmId"),
        this.$t("deforestation.producerName"),
        this.$t("deforestation.addressOfProduction"),
        this.$t("deforestation.areaHa"),
        this.$t("deforestation.type"),
        this.$t("deforestation.EUDRDeforestationStatus"),
        this.$t("dueDiligence.actions"),
      ],
      getManualRiskMitigationData:{
        riskMitigationComment: "",
        riskMitigationFiles: null
      },
      analyzingDeforestation:{
        analyzingStatus : this.$t('deforestation.processingDialog.modalHeader'),
        analyzingDesc: this.$t('deforestation.processingDialog.modalDescription_second')
      },
      showProcessingDialog: false,
      showDisputeModal: false,
      showMitigtionModal: false,
      progressValue: 0,
      progressColor: "green",
      farm: {
        name: "",
        registrationNo: "",
        govRegistrationNo: "",
        farmType: "",
        farmOwner: null,
        lat: "",
        log: "",
        farmOwnershipType: "personal",
        country: "",
        state: "",
        city: "",
        countryId: null,
        stateId: null,
        cityId: null,
        address: "",
        area: "",
        areaUomId: 2,
        parameter: 0,
        parameterUomId: 0,
        street: "",
        farmSize: 0,
        farmSizeUomId: 0,
        farmPerimeter: 0,
        farmPerimeterUomId: 1,
        farmGeofence: [],
        farmingGoalOptId: null,
        productionType: "",
        certifications: [],
        farmingGoalsIds: [],
        farmerFirstName: "",
        farmerMiddleName: "",
        farmerLastName: "",
        isTechnician: false,
        technicianId: null,
        farmerId: "",
        userId: "",
        farmGeofenceName: "",
        farmGeofenceCategory: "",
        farmTitleDocument: "",
        farmTitleDocumentUrl: "",
      },
      countryModel: [],
      statusModel: "",
      producerModel: "",

      countries: [{ text: this.$t("deforestation.allCountries"), val: null }],
      allStatus: [
                { text: this.$t("deforestation.allStatus"), val: ""},
                { text: this.$t("deforestation.veryHighProbability"), val: "Very High Deforestation Probability"},
                { text: this.$t("deforestation.highProbability"), val: "High Deforestation Probability" },
                { text: this.$t("deforestation.mediumProbability"), val: "Medium Deforestation Probability" },
                { text: this.$t("deforestation.lowProbability"), val: "Low Deforestation Probability" },
                { text: this.$t("deforestation.veryLowProbability"), val: "Very Low Deforestation Probability" },
                { text: this.$t("deforestation.zeroOrNegligibleProbability"), val: "Zero/Negligible Deforestation Probability"},
                { text: this.$t("deforestation.zeroOrNegligibleRisk"), val: "Zero/Negligible Risk" },
                { text: this.$t("deforestation.riskDetected"), val: "Risk Detected" },
                { text: this.$t("dueDiligence.manualMitigated"), val: "Manually Mitigated" },
            ],
      allProducers: [{ text: this.$t("deforestation.allProducer"), val: "" }],
      productionPlaces: [],
      removedProductionPlaces: [],
      totalProductionPlaces: 0,
      totalRemovedProductionPlaces: 0,
      copyReport: [],
      loading: true,
      removedLoading: false,
      tab: 0,
      selectedItem: false,
      options: {
        page: 1,
        limit: 10,
        diligenceReportId: 1,
      },

      removedProductionPlaceOptions: {
        page: 1,
        limit: 10,
        diligenceReportId: 1,
      },
      search: "",
      from: 0,
      to: 0,
      removedFrom: 0,
      removedTo: 0,
      headers: [
        {
          text: this.$t("deforestation.productionPlacesFarmAndFarmId"),
          align: "start",
          value: "farm.farmName",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("deforestation.producerName"),
          align: "start",
          value: "farm.userDdsAssoc.fullName",
          class: "black--text",
          sortable: true,

        },

        {
          text: this.$t("deforestation.addressOfProduction"),
          align: "start",
          value: "farm.address",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("deforestation.areaHa"),
          align: "start",
          value: "farm.area",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("deforestation.type"),
          align: "center",
          value: "farmType",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("deforestation.EUDRDeforestationStatus"),
          align: "center",
          value: "eudr_deforestation_status",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("dueDiligence.actions"),
          align: "center",
          value: "status",
          class: "black--text",
          sortable: false,
        },
      ],
      headersRemoveFarm: [
        {
          text: this.$t("deforestation.productionPlacesFarmAndFarmId"),
          align: "start",
          value: "farm.farmName",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("deforestation.producerName"),
          align: "start",
          value: "farm.userDdsAssoc.fullName",
          class: "black--text",
          sortable: true,

        },

        {
          text: this.$t("deforestation.addressOfProduction"),
          align: "start",
          value: "farm.address",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("deforestation.areaHa"),
          align: "start",
          value: "farm.area",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("deforestation.type"),
          align: "center",
          value: "farmType",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("deforestation.EUDRDeforestationStatus"),
          align: "center",
          value: "eudr_deforestation_status",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("dueDiligence.actions"),
          align: "center",
          value: "status",
          class: "black--text",
          sortable: false,
        },
      ],
      breadcrumbs: [
        {
          text: this.$t("deforestation.dueDeligence"),
          disabled: false,
          to: { name: "CreateNewDueDeligenceReport" },
          exact: true,
        },
        {
          text: this.$t("deforestation.createNewReport"),
          disabled: true,
          href: "breadcrumbs_link_1",
        },
      ],
      uploadedFile: null,
      s3Location: "",
      uploadedFileName: "",
      fileError: "No error",
      s3key: "",
      uploadFileType: "",
      fileUploading: false,
      targetedProductionPlaceId: null,
      targetProductionPlace: null,
      risk: false,
      reportLoading: true,
      highRiskComment: null,
      showUploadAssessment: false,
      showViewAssessment: false,
      currentProductionDetails: null,
      updatedEUDRAssessmentType: "Dimitra Deforestation Report",
    
      farmConfirmDeleteDialog : false,
      farmConfirmDelete: {
        title: this.$t("confirmDialog.farm.delete.title"),
        message: this.$t("confirmDialog.farm.delete.message"),
        confirmBtnText: this.$t("confirmDialog.farm.delete.confirmBtn"),
        cancelBtnText: this.$t("cancel"),
        confirmData: {},
      },
      eudrDeforestationStatusConfirmDelete: {
        title: this.$t("confirmDialog.status.delete.title"),
        message: this.$t("confirmDialog.status.delete.message"),
        cancelBtnText: this.$t("cancel"),
        confirmBtnText: this.$t("confirmDialog.status.delete.confirmBtn"),
        confirmData: {}, 
        dialog: false,
      },
      eventHandlersDeforestationStatus: {}, 
    }
  },
  methods: {
    async handleCheckboxWithIssue(){
      await this.getProductionPlaces()
    },
    resetDefault() {
          this.selectedHeaders = this.allSelectedHeaders;
          this.tableHeaders = this.headers;
          this.options.limit = 10;
          this.itemsPerPageSlider = 1;
          this.clearTablePrefs('ProductionPlacesTable');
          this.getProductionPlaces();
        },
       async resetTableStructure() {
          this.customizeMenu = false;
          if (!this.selectedHeaders.length) {
            this.selectedHeaders = this.allSelectedHeaders;
          }
          this.tableHeaders = this.headers.filter(h => this.selectedHeaders.includes(h.text));
          const selectedPerPage = this.itemsPerPageOptions[this.itemsPerPageSlider];
          this.options.limit = selectedPerPage;
          this.options.itemsPerPage = selectedPerPage;

          console.log(selectedPerPage, "selectedPerPage")
          this.setTablePrefs('ProductionPlacesTable', {
            selectedHeaders: this.selectedHeaders,
            itemsPerPage: selectedPerPage
          });

          await this.getProductionPlaces();
        },
    setEventHandlers() {
      this.eventHandlersDeforestationStatus = {
        'cancel:action': () => this.clearEUDRDeforestationStatusCancel(),
        'continue:action': (action, farmDetails) => this.clearEUDRDeforestationStatus(farmDetails), // Receive farmDetails
      };
    },
    clearEUDRDeforestationStatusCancel(){
      this.eudrDeforestationStatusConfirmDelete.confirmData = {};
      this.eudrDeforestationStatusConfirmDelete.dialog = false;
    },
    callbackMitigation(){
      this.getProductionPlaces();
      this.$emit('calculateWarningsForDeforestationAssessment', this.diligenceId);
    },
    onProcessingDialogClose() {
      this.$router.push({ name:"dueDiligenceReports" });
    },
    getEUDRDeforestationStatus(status) {
      return getEUDRDeforestationStatus(status, this.$t.bind(this));
    },
    async triggerSubmit() {
      const confirmed = await this.confirmEudrAssessmentNextStep()
      return confirmed
    },
    getProductionPlaceEudrStatus(item) {
      return item?.eudr_deforestation_status
        || item?.deforestationStatus
        || item?.deforestationInfo?.deforestationStatus
        || item?.errorStatus
        || null
    },
    isAllowedProductionPlaceForPtsiProceed(item) {
      return isAllowedPtsiEudrProceedStatus(this.getProductionPlaceEudrStatus(item))
    },
    mapProductionPlaceRow(item) {
      const deforestationInfo = item.diligenceReportProductionPlaceArray?.[0]?.productionPlaceDeforestationInfo
      return {
        ...item,
        deforestationInfo,
        deforestationStatus: deforestationInfo?.deforestationStatus,
        isExpired: isDeforestationExpired(deforestationInfo?.deforestationStatusDate, this.get_EUDR_Settings),
        errorStatus: deforestationInfo?.deforestationReport?.errorStatus,
      }
    },
    async confirmEudrAssessmentNextStep() {
      if (!this.isIndonesianClient) {
        return true
      }

      this.startLoading()
      try {
        const res = await DeforestationService.getDiligenceReportEudrAssessmentSummary(this.diligenceId)
        const summary = res?.data?.diligenceReportEudrAssessmentSummary
        if (summary?.canProceed) {
          this.blockingEudrFarms = []
          return true
        }

        this.blockingEudrFarms = (summary?.blockingFarms || []).map((farm) => ({
          id: farm.productionPlaceId,
          farm: {
            id: farm.farmId,
            farmName: farm.farmName,
          },
          eudr_deforestation_status: farm.eudrDeforestationStatus,
          deforestationStatus: farm.eudrDeforestationStatus,
        }))
      } catch (error) {
        console.error('Failed to load EUDR assessment summary', error)
        this.$notify({ text: this.$t('somethingWentWrong'), type: 'error' })
        return false
      } finally {
        this.stopLoading()
      }

      if (!this.blockingEudrFarms.length) {
        return true
      }
      return new Promise((resolve) => {
        this.nextConfirmResolve = resolve
        this.nextConfirmDialog = true
      })
    },
    cancelNextStep() {
      this.nextConfirmDialog = false
      if (this.nextConfirmResolve) {
        this.nextConfirmResolve(false)
        this.nextConfirmResolve = null
      }
    },
    triggerFileInput() {
      this.fileUploading = true;
      this.$refs.fileInput.click();
    },
    openPdf(){
      window.open(this.s3Location);
    },
    async getDiligenceDetail() {
      const id = this.$route.params.id || null
      DeforestationService.getDiligenceDetail(parseInt(id)).then(res => {
        this.$store.commit('eudrDDS/SET_DILIGENCE_DETAILS', res.data.getDiligenceDetail);
      })
      const diligenceDetails = this.getDiligenceDetails;
      if (diligenceDetails) {
        this.updatedEUDRAssessmentType = diligenceDetails.eudrAssessmentType;
        this.risk = diligenceDetails.totalHighDeforestationProductionPlaces > 0;
      }
    },
    handleUploadEudrAssessment(item) {
      this.currentProductionDetails = item;
      this.showUploadAssessment = true;
    },

    handleViewEudrAssessment(item) {
      this.currentProductionDetails = item;
      this.showViewAssessment = true;
    },

    async uploadedEudrDeforestations() {
      this.showUploadAssessment = false;
      this.showViewAssessment = false;
      await this.getProductionPlaces();
    },
    onClickRemoveDeforestationStatus(data) {
      this.eudrDeforestationStatusConfirmDelete.confirmData = data;
      this.eudrDeforestationStatusConfirmDelete.dialog = true;
    },
    async clearEUDRDeforestationStatus(farmDetails) {
      this.startLoading();
      let payloadData = {
        farm_id: [parseInt(farmDetails.id)],
        diligence_report_id: parseInt(this.diligenceId),
        eudr_deforestation_status: null,
        eudr_s3_key: "",
        eudr_s3_location: "",
        eudr_comment: "",
      };
      DeforestationService.updateDeforestationStatus(payloadData)
        .then(async (res) => {
          if (res.errors && res.errors.length > 0) {
            this.stopLoading();
            const errorMessage =
              res.errors[0].message || "An unexpected error occurred.";
            this.$notify({
              type: "error",
              text: errorMessage,
            });
            return;
          }
          if (res.data) {
            const {
              success,
            } = res?.data?.updateManualEUDRDeforestationStatus;
            if (success) {
              this.$notify({
                title: "EUDR deforstation status removed successfully.",
                type: "success",
              });

              await this.getProductionPlaces();

            } else {
              this.$notify({
                title: this.$t('somethingWentWrong'),
                type: "error",
              });
            }
          }
        })
        .catch((err) => {
          this.$notify({
            title: err.message || this.$t('somethingWentWrong'),
            type: "error",
          });
        })
        .finally(() => {
          this.stopLoading();
        });
        this.clearEUDRDeforestationStatusCancel();
    },

    async handleFileChange(event) {
      const file = event.target.files[0];
      if (file && file.type === "application/pdf") {
        this.uploadedFile = file;
        this.uploadedFileName = file.name;
        this.uploadFileType = file.name
          .split(".")
          .pop()
          .toUpperCase();
        await this.uploadFile(file);
      } else {
        this.fileUploading = false;
        console.error("Invalid file type. Please select a PDF file.");
      }
    },

    async uploadFile(file) {
      this.startLoading();
      this.uploadedFile = file;
      this.uploadedFileName = file.name;
      this.uploadFileType = file.name
        .split(".")
        .pop()
        .toUpperCase();
        try{
          const result = await S3UploadService.singleUpload(file, "signatures");
          this.s3Location = result.fullPath;
          this.s3key = result.key;
          console.log("File uploaded successfully:", this.s3Location);
          
          // Log the file upload
          try {
            const userId = this.$store.getters.getUser?.id;
            if (userId) {
              await ActivityLogService.logDDSFileUploaded(
                this.diligenceId,
                userId,
                file.name,
                this.uploadFileType,
                'Risk mitigation signature'
              );
            }
          } catch (logError) {
            console.error('Error logging file upload:', logError);
          }
          
          await this.highRiskMitigation();
        } catch(err){
            this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Error generating signed URL from S3'
          });
        }
        this.stopLoading();
    },

    parseMitigationDeepLinkQuery() {
      const query = this.$route?.query || {}
      if (query.openMitigation !== '1') return null

      if (
        query.mitigationContext
        && query.mitigationContext !== DDS_MITIGATION_SOURCE_TYPE.EUDR_DEFORESTATION
      ) {
        return null
      }

      const toInt = (value) => {
        if (value == null || value === '') return null
        const parsed = parseInt(value, 10)
        return Number.isNaN(parsed) ? null : parsed
      }

      return {
        farmId: toInt(query.mitigationFarmId),
        productionPlaceId: toInt(query.mitigationProductionPlaceId),
        revisionComment: query.mitigationRevisionComment || '',
      }
    },
    clearMitigationDeepLinkQuery() {
      const query = { ...this.$route.query }
      delete query.openMitigation
      delete query.mitigationContext
      delete query.mitigationFarmId
      delete query.mitigationProductionPlaceId
      delete query.mitigationRevisionComment
      this.$router.replace({ query }).catch(() => {})
    },
    async findProductionPlaceForMitigationDeepLink(criteria) {
      let item = findProductionPlaceForMitigation(this.productionPlaces, criteria)
      if (item) return item

      const originalPage = this.options.page
      const originalLimit = this.options.limit
      const pageSize = 100

      this.options.page = 1
      this.options.limit = pageSize
      await this.getProductionPlaces()
      item = findProductionPlaceForMitigation(this.productionPlaces, criteria)
      if (item) return item

      const totalPages = Math.max(1, Math.ceil(this.totalProductionPlaces / pageSize))
      for (let page = 2; page <= totalPages; page += 1) {
        this.options.page = page
        await this.getProductionPlaces()
        item = findProductionPlaceForMitigation(this.productionPlaces, criteria)
        if (item) return item
      }

      this.options.page = originalPage
      this.options.limit = originalLimit
      await this.getProductionPlaces()
      return null
    },
    async handleMitigationDeepLink() {
      const criteria = this.parseMitigationDeepLinkQuery()
      if (!criteria) return

      const hasTarget = criteria.farmId || criteria.productionPlaceId
      if (!hasTarget) {
        this.clearMitigationDeepLinkQuery()
        return
      }

      const farmItem = await this.findProductionPlaceForMitigationDeepLink(criteria)
      this.clearMitigationDeepLinkQuery()

      if (!farmItem) {
        this.$notify({
          text: 'Could not find the farm for mitigation. Please open mitigation from the list.',
          type: 'warning',
        })
        return
      }

      this.$nextTick(() => {
        this.showModel('mitigation', farmItem)
      })
    },

    showModel(modal, item) {
      switch (modal) {
        case "disputes":
          this.targetProductionPlace = item;
          this.showDisputeModal = true;

          break;
        case "assessment":
          this.$router.push({
            name: "EudrAssessmentReportDDS",
            params: { reportRequestId: item.deforestationInfo.deforestationReportRequestId, type: "assignment" },
          });

          break;
        case "mitigation":
          this.getManualRiskMitigationData = {
            riskMitigationComment : item.risk_mitigation_comment,
            riskMitigationFiles : item.risk_mitigation_files
          }
          this.targetedProductionPlaceId = item.diligenceReportProductionPlaceArray[0]?.id;
          this.targetProductionPlace = item;
          this.showMitigtionModal = true;
          break;

        default:
          break;
      }
    },
    closeWithoutChange() {
      this.$emit("close-without-change");
    },

    closeModal(data = null) {
      //   this.polygon.setMap(null);
      //   this.parentPolygonCoords = [];
      this.$emit("close-location-modal", data);
    },

    async fetchData() {
      try {
        await Promise.allSettled([
          this.getDiligenceDetail(this.diligenceId),
          this.getProductionPlaces(),
          this.getRemovedProductionPlaces()
        ]);
      } catch (error) {
        console.error(error)
      }
    },

    debouncedGetProductionPlaces: debounce(function(){
        // reset into first page.
            this.tableOptions = {
                page: 1,
                itemsPerPage: 10
            }
            this.getProductionPlaces();
        }, 1000), // debounce delay,

    async getBulkDeforestationReport() {
      this.reportLoading = true;
      try {
        if (this.updatedProductionPlaces.length) {
          const response = await DeforestationService.getBulkReportByDiligenceId(this.diligenceId);
          if(!response.data?.success) {
            throw new Error(response.data.message);
          }
          const job = response.data.data;
          let stopWaiting = false;
          let dialogTimeout;
          
          this.startTimer++;
          this.showProcessingDialog = true;
          this.stopLoading();
          
          // Set dialog timeout to close after 30 seconds and redirect
          dialogTimeout = setTimeout(() => {
            this.showProcessingDialog = false;
            this.$router.push({ name:"dueDiligenceReports" });
          }, 30000); // 30 seconds timeout for dialog
          
          while(!stopWaiting) {
            await wait(5000);
            const response = await DeforestationService.getJob(job.id);
            if(response.data?.job.status === 'Failed') {
              if (dialogTimeout) clearTimeout(dialogTimeout);
              this.showProcessingDialog = false;
              throw new Error(response.data.job.context?.error || 'An error occurred while fetching the deforestation report.');
            }
            if(response?.data.job.status === 'Completed') {
              if (dialogTimeout) clearTimeout(dialogTimeout);
              this.showProcessingDialog = false;
              this.$notify({
                type: 'success',
                title: 'Success',
                text: this.$t("dueDiligence.successfullyGeneratedEUDRDeforestationStatus"),
              });
              this.progressValue = 100;
              await this.getDiligenceDetail(this.diligenceId);
              await this.getProductionPlaces();
              break;
            }
          }
        } else {
          this.progressValue = 100;
        }
      } catch (error) {
        this.progressValue = 0;
        this.progressColor = "red";
        this.$notify({
          type: 'error',
          title: 'Error',
          text: error.message || this.$t('deforestation.anErrorOccuredWhileFetchingTheDeforestationReport')
        });
      } finally {
        this.reportLoading = false;
      }
    },

    async removeFarm(id) {
      this.farmConfirmDelete.confirmData = { id };
      this.farmConfirmDeleteDialog = true;
    },

    async confirmRemoveFarm(action, confirmData) {
      this.startLoading();
      const params = {
        diligenceReportId: this.diligenceId,
        farmId: confirmData.id,
      };
      
      try {
        await DeforestationService.removeFarmFromProductionPlaceListById(params);
        
        // Log the farm removal
        try {
          const userId = this.$store.getters.getUser?.id;
          if (userId) {
            await ActivityLogService.logDDSProductionPlaceDeleted(
              this.diligenceId,
              userId,
              confirmData.id,
              '', // farmName not available in this context
              'EUDR assessment deletion'
            );
          }
        } catch (logError) {
          console.error('Error logging farm removal:', logError);
        }
        
        await this.fetchData();
        this.farmConfirmDeleteDialog = false;
      } catch (error) {
        console.error('Error removing farm:', error);
        this.$notify({
          title: this.$t('somethingWentWrong'),
          type: 'error'
        });
      } finally {
        this.stopLoading();
      }
    },
    async restoreFarm(id) {
      this.startLoading();
      const params = {
        diligenceReportId: this.diligenceId,
        farmId: id,
      };
      
      try {
        await DeforestationService.restoreProductionPlaceFarmById(params);
        
        // Log the farm restoration
        try {
          const userId = this.$store.getters.getUser?.id;
          if (userId) {
            await ActivityLogService.logDDSProductionPlaceRestored(
              this.diligenceId,
              userId,
              id,
              '' // farmName not available in this context
            );
          }
        } catch (logError) {
          console.error('Error logging farm restoration:', logError);
        }
        
        await this.fetchData();
      } catch (error) {
        console.error('Error restoring farm:', error);
        this.$notify({
          title: this.$t('somethingWentWrong'),
          type: 'error'
        });
      } finally {
        this.stopLoading();
      }
    },

    async removeAllMediumRiskFarm() {
      this.startLoading();
      const params = {
        diligenceReportId: this.diligenceId,
        eudrDeforestationStatus: "Medium Deforestation Probability",
      };
      
      try {
        const res = await DeforestationService.removeFarmFromProductionPlaceListByStatus(params);
        const { success, message } = res.data.removeFarmFromProductionPlaceList;
        
        if (success) {
          // Log the bulk removal of medium-risk farms
          try {
            const userId = this.$store.getters.getUser?.id;
            if (userId) {
              await ActivityLogService.logDDSProductionPlaceBulkDeleted(
                this.diligenceId,
                userId,
                'multiple', // count not available in response
                'Medium Deforestation Probability'
              );
            }
          } catch (logError) {
            console.error('Error logging bulk farm removal:', logError);
          }
          
          await this.getProductionPlaces();
          this.$notify({
            title: message || "Item deleted successfully.",
            type: 'success'
          })
        } else {
          this.$notify({
            title: message || this.$t('somethingWentWrong'),
            type: 'error'
          })
        }
        await this.fetchData();
      } catch (error) {
        console.error('Error removing medium-risk farms:', error);
        this.$notify({
          title: this.$t('somethingWentWrong'),
          type: 'error'
        });
      } finally {
        this.stopLoading();
      }
    },

    async removeAllHighRiskFarm() {
      this.startLoading();
      const params = {
        diligenceReportId: this.diligenceId,
        eudrDeforestationStatus: "High Deforestation Probability",
      };
      
      try {
        const res = await DeforestationService.removeFarmFromProductionPlaceListByStatus(params);
        const { success, message } = res.data.removeFarmFromProductionPlaceList;
        
        if (success) {
          // Log the bulk removal of high-risk farms
          try {
            const userId = this.$store.getters.getUser?.id;
            if (userId) {
              await ActivityLogService.logDDSProductionPlaceBulkDeleted(
                this.diligenceId,
                userId,
                'multiple', // count not available in response
                'High Deforestation Probability'
              );
            }
          } catch (logError) {
            console.error('Error logging bulk farm removal:', logError);
          }
          
          await this.getProductionPlaces();
          this.$notify({
            title: message || "Item deleted successfully.",
            type: 'success'
          })
        } else {
          this.$notify({
            title: message || this.$t('somethingWentWrong'),
            type: 'error'
          })
        }
        await this.fetchData();
      } catch (error) {
        console.error('Error removing high-risk farms:', error);
        this.$notify({
          title: this.$t('somethingWentWrong'),
          type: 'error'
        });
      } finally {
        this.stopLoading();
      }
    },

    async removeAllLowRiskFarm() {
      this.startLoading();
      const params = {
        diligenceReportId: this.diligenceId,
        eudrDeforestationStatus: "Low Deforestation Probability",
        // eudrDeforestationStatus: "Zero/Negligible Deforestation Probability",
      };
      
      try {
        const res = await DeforestationService.removeFarmFromProductionPlaceListByStatus(params);
        const { success, message } = res.data.removeFarmFromProductionPlaceList;
        
        if (success) {
          // Log the bulk removal of low-risk farms
          try {
            const userId = this.$store.getters.getUser?.id;
            if (userId) {
              await ActivityLogService.logDDSProductionPlaceBulkDeleted(
                this.diligenceId,
                userId,
                'multiple', // count not available in response
                'Low Deforestation Probability'
              );
            }
          } catch (logError) {
            console.error('Error logging bulk farm removal:', logError);
          }
          
          await this.getProductionPlaces();
          this.$notify({
            title: message || "Risk mitigated successfully.",
            type: 'success'
        })
        } else {
          this.$notify({
            title: message || this.$t('somethingWentWrong'),
            type: 'error'
          })
        }
        await this.fetchData();
      } catch (error) {
        console.error('Error removing low-risk farms:', error);
        this.$notify({
          title: this.$t('somethingWentWrong'),
          type: 'error'
        });
      } finally {
        this.stopLoading();
      }
    },

    handleHightRiskMitigation : debounce(function(){
      this.highRiskMitigation();
    }, 3000),

    async highRiskMitigation() {
      this.startLoading();
      const params = {
        due_diligence_report_id: this.diligenceId,
        risk_mitigation_comment: this.highRiskComment,
        eudr_deforestation_status: "Manually Mitigated",
        file: this.s3Location || '',
      };
      try {
        const res =await DeforestationService.highRiskFarmRiskMitigation(params);
        const {message, success} = res.data?.highRiskFarmsRiskMitigation
        if (success) {
          // Log the successful risk mitigation
          try {
            const userId = this.$store.getters.getUser?.id;
            if (userId) {
              await ActivityLogService.logDDSManualMitigationCompleted(
                this.diligenceId,
                userId,
                null, // farmId not available in this context
                '', // farmName not available in this context
                'High risk deforestation',
                'Successfully mitigated'
              );
            }
          } catch (logError) {
            console.error('Error logging risk mitigation:', logError);
          }

          this.$notify({
            title: message || "Item deleted successfully.",
            type: 'success'
          })
        }
        else {
          this.$notify({
            title: message || this.$t('somethingWentWrong'),
            type: 'error'
          })
        }
        await this.fetchData();
        this.$emit('calculateWarningsForDeforestationAssessment', this.diligenceId);
      } catch (error) {
        this.$notify({
          text: error.message || "An unexpected error occurred. Please try again later.",
          type: 'error',
        });
      }
      finally {
        this.stopLoading();
      }
    },
    async getProductionPlaces(opt = null) {
      this.loading = true;
      const requestParams = {
        page: this.options.page,
        limit: this.options.limit,
        diligenceReportId: this.diligenceId,
        removed: false,
        searchPhrase: this.search,
        eudrDeforestationStatus:this.statusModel,
        farmCountry:this.countryModel,
        farmOwner:this.producerModel,
        issue_farm:this.issue_farm
      };
  
      if (opt?.sortBy?.length) {
        requestParams.orderField = opt.sortBy[0];
        requestParams.order = opt.sortDesc[0] ? "DESC" : "ASC";
      }

      await DeforestationService.getProductionPlaces(requestParams)
        .then((res) => {
          this.productionPlaces = res.data.productionPlaces.rows.map((item) => {
            const deforestationInfo = item.diligenceReportProductionPlaceArray?.[0]?.productionPlaceDeforestationInfo;
            return {
              ...item,
              deforestationInfo,
              deforestationStatus: deforestationInfo?.deforestationStatus,
              isExpired: isDeforestationExpired(deforestationInfo?.deforestationStatusDate, this.get_EUDR_Settings),
              errorStatus: deforestationInfo?.deforestationReport?.errorStatus
            };
          });

          this.totalProductionPlaces = res.data.productionPlaces.totalCount;
          this.from = (this.options.page - 1) * this.options.limit + 1;
          this.to = this.options.page * this.options.limit;
          if (this.productionPlaces.length > 0) {
            this.to -= this.options.limit - this.productionPlaces.length;
          } else {
            this.to -= this.options.limit;
          }
          const countryLists = this.productionPlaces
            .filter((item) => item.farm.userDdsAssoc.countryId)
            .map((item) => {
              return {
                text: item.farm.userDdsAssoc.countryId,
                val: item.farm.userDdsAssoc.countryId,
              };
            });
          const producerList = this.productionPlaces
            .filter((item) => {
              return item.farm.userDdsAssoc.firstName;
            })
            .map((item) => {
              const fullName = `${item.farm.userDdsAssoc.firstName
                ? item.farm.userDdsAssoc.firstName
                : ""
                } ${item.farm.userDdsAssoc.lastName ? item.farm.userDdsAssoc.lastName : ""
                }`;
              return {
                text: `${fullName}`,
                val: `${item.farm.userDdsAssoc.firstName}`,
              };
            });
          this.countries = [...this.countries, ...countryLists];
          this.allProducers = [...this.allProducers, ...producerList];

          if (this.productionPlaces.length > 0) {
            const productionPlacesWithRiskMitigation = this.productionPlaces.filter(place => {
              const reportPlace = place.diligenceReportProductionPlaceArray[0];
              return reportPlace?.productionPlaceDeforestationInfo?.deforestationMitigationComment && reportPlace?.riskMitigationFiles?.length;
            });
            if(productionPlacesWithRiskMitigation.length) {
              let firstData = productionPlacesWithRiskMitigation[0];
              this.highRiskComment = firstData.diligenceReportProductionPlaceArray[0].productionPlaceDeforestationInfo.deforestationMitigationComment;
              const file = firstData.diligenceReportProductionPlaceArray[0].riskMitigationFiles[0].file_path;
              this.s3Location = file;
              this.uploadFileType = file.split('.').pop();
              this.uploadedFileName = file.split('/').pop();
              const allSameData = productionPlacesWithRiskMitigation.every(place => {
                return place.diligenceReportProductionPlaceArray[0]?.productionPlaceDeforestationInfo?.deforestationMitigationComment === this.highRiskComment;
              });
              // this will work if all rows have the same risk_mitigation_comment but in our case that isn't so i added this condition in above firstly.
              if (!allSameData) {
                this.s3Location = null;
                this.uploadFileType = null;
                this.uploadedFileName = null;
              }
            }

          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.log("Error", err);
        });
    },

    async getRemovedProductionPlaces(opt = null) {
      this.removedLoading = true;
      const requestParams = {
        page: this.removedProductionPlaceOptions.page,
        limit: 10,
        diligenceReportId: this.diligenceId,
        removed: true,
        eudrDeforestationStatus:this.statusModel,
        farmCountry:this.countryModel,
        farmOwner:this.producerModel
      };
      if (opt?.sortBy?.length) {
        requestParams.orderField = opt.sortBy[0];
        requestParams.order = opt.sortDesc[0] ? "DESC" : "ASC";
      }
      await DeforestationService.getProductionPlaces(requestParams)
        .then((res) => {
          this.removedProductionPlaces = res.data.productionPlaces.rows.map((item) => {
            const deforestationInfo = item.diligenceReportProductionPlaceArray?.[0]?.productionPlaceDeforestationInfo;
            return {
              ...item,
              deforestationInfo,
              deforestationStatus: deforestationInfo?.deforestationStatus,
              errorStatus: deforestationInfo?.deforestationReport?.errorStatus
            };
          });

          this.totalRemovedProductionPlaces =
            res.data.productionPlaces.totalCount;
          this.removedFrom =
            (this.removedProductionPlaceOptions.page - 1) *
            this.removedProductionPlaceOptions.limit +
            1;
          this.removedTo =
            this.removedProductionPlaceOptions.page *
            this.removedProductionPlaceOptions.limit;

          if (this.removedProductionPlaces.length > 0) {
            this.removedTo -=
              this.removedProductionPlaceOptions.limit -
              this.removedProductionPlaces.length;
          } else {
            this.removedTo -= this.removedProductionPlaceOptions.limit;
          }
          this.removedLoading = false;
        })
        .catch((err) => {
          this.removedLoading = false;
          console.log("Error", err);
        });
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    searchQuery() {
      this.getProductionPlaces();
    },
    resetSearchOnEmpty() {
      this.search = "";
      this.countryModel = "";
      this.statusModel = "";
      this.regionModelregionModel = "";
      this.options = {
        page: 1,
        limit: 10,
      };
      this.getDeforestationEUDR();
    },
    pageChange(t) {
      if (t) this.options.page = this.options.page + 1;
      else this.options.page = this.options.page - 1;
      this.getProductionPlaces();
    },

    pageChangeRemovedProductionPlace(t) {
      if (t)
        this.removedProductionPlaceOptions.page =
          this.removedProductionPlaceOptions.page + 1;
      else
        this.removedProductionPlaceOptions.page =
          this.removedProductionPlaceOptions.page - 1;
      this.getRemovedProductionPlaces();
    },
    async exportToPDF() {
      const requestParams = {
        page: this.options.page,
        limit: this.options.limit,
        diligenceReportId: this.diligenceId,
        removed: false,
        searchPhrase: this.search,
        eudrDeforestationStatus:this.statusModel,
        farmCountry:this.countryModel,
        farmOwner:this.producerModel
      };
      const querys = new URLSearchParams(requestParams).toString();
      const token = this.$store.state.auth.token
      this.startLoading()
      const url = localStorage.getItem('CF_DEFORESTATION_API_BASE_URL') || process.env.VUE_APP_DEFORESTRATION_API_BASE_URL  || "http://localhost:4043/api"
      this.downloadSourceFileWithToken(`${url}/production-place/production-place-with-status-pdf?${querys}`, "application/pdf", token,"production-places.pdf")
          .then(() => {
          this.stopLoading()
          }).catch(() => {
          this.stopLoading()
      })
    },
  },
  watch: {
  getDiligenceDetails: {
      handler(newDetails) {
        if (newDetails) {
          const diligenceDetails = this.getDiligenceDetails;
          console.log("eudrAssessmentType", this.getDiligenceDetails, diligenceDetails?.eudrAssessmentType);
          if (diligenceDetails) {
            this.updatedEUDRAssessmentType = diligenceDetails.eudrAssessmentType;
            this.risk = diligenceDetails.totalHighDeforestationProductionPlaces > 0;
          }
        }
      },
      immediate: true,
    },
  },
  mixins: [tableCustomizationMixin, loadingMixin, download, getPermittedActions, DateMixin, reportReadonlyMixin],
};
</script>
<style lang="scss" scoped>
.eudr-proceed-dialog-card {
  border-radius: 12px;
  overflow: hidden;
  position: relative;
}

.eudr-proceed-dialog__icon-wrap {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #ffebee;
  margin: 0 auto 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.eudr-proceed-dialog__lead {
  color: #da3d3d;
}

.eudr-proceed-dialog__farm-list {
  max-height: 180px;
  overflow-y: auto;
}

.eudr-proceed-dialog__helper {
  background: #f0f7ff;
  border: 1px solid #d6e8ff;
}

.eudr-proceed-dialog__helper-steps {
  list-style: none;
  counter-reset: eudr-helper-step;
}

.eudr-proceed-dialog__helper-steps li {
  position: relative;
  padding-left: 28px;
  margin-bottom: 10px;
  color: #374151;
  line-height: 1.45;
}

.eudr-proceed-dialog__helper-steps li:last-child {
  margin-bottom: 0;
}

.eudr-proceed-dialog__helper-steps li::before {
  counter-increment: eudr-helper-step;
  content: counter(eudr-helper-step);
  position: absolute;
  left: 0;
  top: 1px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #0170e5;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
}

.eudr-proceed-dialog__timing-note {
  padding-top: 10px;
  border-top: 1px solid #d6e8ff;
  text-align: left;
}

.eudr-proceed-dialog__actions {
  gap: 10px;
}

.eudr-proceed-dialog__close {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
}

::v-deep .wdt.v-text-field {
  width: 250px;
}

::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}

::v-deep .v-data-table-header span {
  text-transform: none !important;
  color: #FFFFFF !important;
}

::v-deep .center-content {
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .img-center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 40%;
}

::v-deep .v-list-item {
  cursor: pointer !important;

  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }
}

::v-deep .eudr_class{
  display: flex;
  justify-content: left;
  align-items: center
}

::v-deep .non-clickable {
    pointer-events: none;
    cursor: default;
  }

/* Responsive Filter Controls */
.filter-controls-bar {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 16px;
}

.filter-controls-left {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  flex: 1;
  min-width: 0;
}

.filter-item {
  min-width: 200px;
  flex-shrink: 0;
}

.search-field {
  min-width: 200px;
}

.filter-controls-checkbox-row {
  display: flex;
  justify-content: flex-end;
  margin-top: -4px;
  margin-bottom: 8px;
}

.filter-controls-checkbox-row ::v-deep .v-label {
  white-space: nowrap;
}

.filter-controls-checkbox-row ::v-deep .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

.filter-controls-checkbox-row ::v-deep .v-input--selection-controls__ripple {
  margin: 0;
}

.filter-controls-checkbox-row ::v-deep .v-input__slot {
  margin-bottom: 0;
}

.filter-controls-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.pagination-info {
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
  white-space: nowrap;
}

/* Mobile Controls */
.mobile-controls {
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.mobile-search {
  width: 100%;
}

.mobile-search .v-text-field {
  width: 100%;
}

.eudr-table-wrapper ::v-deep .eudr-type-col {
  width: 100px;
  min-width: 100px;
}

.eudr-table-wrapper ::v-deep th.eudr-status-col,
.eudr-table-wrapper ::v-deep td.eudr-status-col {
  width: auto;
  min-width: 240px;
  white-space: nowrap;
  overflow: visible;
  text-align: center !important;
}

.eudr-table-wrapper ::v-deep td.eudr-status-col .eudr_class {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.eudr-table-wrapper ::v-deep td.eudr-status-col .d-flex {
  justify-content: center;
  width: 100%;
}

.eudr-table-wrapper ::v-deep .eudr-actions-col {
  width: 120px;
  min-width: 120px;
  white-space: nowrap;
}

.bulk-action-buttons {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 40px 8px 24px;
  width: 100%;
}

.bulk-action-buttons__attach {
  display: inline-flex;
  align-items: center;
  padding: 12px 0;
  border-top: 1px solid #e0e0e0;
  width: 100%;
}

.mobile-pagination-info {
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

.mobile-pagination-controls {
  display: flex;
  gap: 8px;
  flex: 0 0 auto;
  max-width: 100%;
}

.bulk-action-buttons__info {
  flex: 0 0 auto;
}

.bulk-action-buttons ::v-deep .bulk-action-btn.v-btn {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
  height: auto !important;
  min-height: 36px;
  padding: 8px 16px !important;
  overflow: visible;
  letter-spacing: normal;
  text-transform: none;
}

.bulk-action-buttons ::v-deep .bulk-action-btn .v-btn__content {
  white-space: normal;
  line-height: 1.35;
  word-break: break-word;
  flex-wrap: wrap;
}

.bulk-action-buttons ::v-deep .bulk-action-btn--attach.v-btn {
  display: inline-flex !important;
  flex: 0 0 auto;
  width: max-content;
  max-width: 100%;
  align-self: flex-start;
}

.bulk-action-buttons ::v-deep .bulk-action-btn--attach .v-btn__content {
  white-space: nowrap;
}

.table-legend {
  gap: 8px 16px;
  padding: 0 8px;
}

.mitigation-panel {
  border-color: #e0e0e0 !important;
  background: #fafafa;
}

.mitigation-panel__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  align-items: start;
  width: 100%;
}

.mitigation-panel__grid--with-doc {
  grid-template-columns: minmax(220px, 320px) minmax(0, 1fr);
}

.mitigation-panel__comments {
  width: 100%;
  min-width: 0;
}

.mitigation-panel__textarea {
  width: 100%;
}

.mitigation-panel__textarea ::v-deep .v-input__control,
.mitigation-panel__textarea ::v-deep .v-input__slot {
  width: 100%;
}

.mitigation-panel__label {
  font-size: 13px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 10px;
}

.mitigation-panel__doc-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.mitigation-panel__doc-card:hover {
  border-color: #bdbdbd;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.mitigation-panel__doc-meta {
  min-width: 0;
  flex: 1;
}

.mitigation-panel__doc-name {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

.removed-farms-section {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}

.removed-farms-section__header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  background: #f5f7fa;
  border-bottom: 1px solid #e8eaed;
}

.removed-farms-section__title-wrap {
  display: flex;
  align-items: center;
  min-width: 0;
}

.removed-farms-section__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
}

.removed-farms-section__pagination {
  display: flex;
  align-items: center;
  gap: 4px;
}

.removed-farms-section__legend {
  padding: 12px 20px 0;
  justify-content: flex-end;
}

.removed-farms-section__legend-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.7);
}

.removed-farms-section__legend-item img {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}

.removed-farms-table {
  padding: 0 12px 16px;
}

.removed-farms-table ::v-deep table {
  min-width: 960px;
}

.removed-farms-table ::v-deep th.eudr-status-col,
.removed-farms-table ::v-deep td.eudr-status-col {
  min-width: 200px;
}

.removed-farms-table__address {
  max-width: 220px;
}

.removed-farms-table__actions {
  gap: 8px;
}

.removed-farms-table__action-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
}

.filter-toolbar--compact {
  margin-top: 12px;
}

.filter-toolbar__actions--full {
  flex: 1 1 100%;
}

@media (max-width: 960px) {
  .filter-controls-bar {
    display: none;
  }
  
  .mobile-controls,
  .mobile-pagination {
    display: flex;
  }
  
  .mobile-controls {
    width: 100%;
  }

  .bulk-action-buttons ::v-deep .bulk-action-btn.v-btn {
    flex: 1 1 100%;
    max-width: 100%;
  }

  .bulk-action-buttons__attach {
    flex: 1 1 100%;
  }

  .bulk-action-buttons ::v-deep .bulk-action-btn--attach.v-btn {
    flex: 1 1 auto;
    width: 100%;
  }

  .bulk-action-buttons ::v-deep .bulk-action-btn--attach .v-btn__content {
    white-space: normal;
  }

  .mitigation-panel__grid {
    grid-template-columns: 1fr;
  }

  .removed-farms-section__header {
    flex-direction: column;
    align-items: flex-start;
  }

  .removed-farms-section__pagination {
    width: 100%;
    justify-content: space-between;
  }
}

@media (max-width: 600px) {
  .filter-item {
    min-width: 100%;
  }
  
  .mobile-controls {
    width: 100%;
  }
  
  .mobile-search {
    width: 100%;
  }
  
  .mobile-pagination {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 12px;
  }
  
  .mobile-pagination-controls {
    justify-content: flex-end;
  }
}
</style>
